<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                Col
                    h2 {{ $t('wafrules.pageTitleText') }}
                Col
                    ExplainBtn(:objectExplanation="objectsExplanation")
            p Control incoming traffic to your domain by filtering requests based on location, IP address, User-Agent, URI, and more.
            strong You have created {{ usage.used }} of {{ usage.max }} wafrules.

        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :actionInTable="true"
            :userCanBatchEdit="false"
            :drawerTitleKey="drawerTitleKey"
            ref="rcmTable"
            :searchView="$options.name"
            drawerWidth="70"
            primarySearchKey="ruleName"
            :primarySearchKeyI18="$t('wafrules.ruleName')"
            :isCreateBtnDisabled="!$can('write', 'domainManagePermission','WafRules')"
            :isEditBtnDisabled="!$can('write', 'domainManagePermission','WafRules')"
            :isDeleteBtnDisabled="!$can('write', 'domainManagePermission','WafRules')"
        )
</template>
<script>
import Vue from "vue";
Vue.component("TagList", TagList);
Vue.component("StringList", StringList);
Vue.component("ExplainHotlink", ExplainHotlink);
Vue.component("ExplainWafRateLimitToken", ExplainWafRateLimitToken);
Vue.component("ExplainWafHeaderType", ExplainWafHeaderType);

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import StringList from "@/components/StringList";
import ExplainHotlink from "@/components/PoptipInfos/ExplainHotlink";
import ExplainWafRateLimitToken from "@/components/PoptipInfos/ExplainWafRateLimitToken";
import ExplainWafHeaderType from "@/components/PoptipInfos/ExplainWafHeaderType";
import bus from "@/libs/bus.js";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";

import { getGroupAsset } from "@/api/groupasset.js";

import { settingZoneExplain, groupName, ruleName, description } from "./fields.js";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);

export default {
    name: "WafRules",
    components: { RcmTable, TagList, StringList },
    data() {
        return {
            esIndex: "rcm-wafrules",
            drawerTitleKey: "ruleName",
            assetCategory: "wafRules",
            usage: { used: "", max: "", available: "" },
            objectsExplanation: {},
            isAlive: true,
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("wafrules.createText");
        },
        esIndexFields() {
            let wafFileds = this.$store.getters.isAdmin
                ? {
                      action: {},
                      createBy: {},
                      groupName: groupName(this),
                      ruleName: ruleName(this),
                      _id: {},
                      usedByFQDNConfigLength: {},
                      wafAction: {},
                      wafCustomHtmlPageName: {},
                      wafDenyHtmlPageName: {},
                      wafOriginPolicyName: {},
                      wafIsDenyThenBucket: {},
                      //   isAllowTcpReset: {},
                      wafDenyThenBucketRate: {},
                      wafBucketTime: {},
                      wafBucketPreSslDeny: {},
                      wafBucketPreSslDenyThreshold: {},
                      wafIsGlobalBucketRecord: {},
                      wafSpeedLimit: {},
                      wafRedirectUrl: {},
                      wafRedirectHttpCode: {},
                      wafSetReqHeaders: {},
                      wafSetResHeaders: {},
                      wafHotlinkSecretKey: {},
                      wafHotlinkTimeToLive: {},
                      wafHotlinkQueryArgument: {},
                      settingZoneExplain: settingZoneExplain(this),
                      wafIp: {},
                      wafUri: {},
                      wafHeaderType: {},
                      wafHeaders: {},
                      wafHeadersSet: {},
                      wafHeadersNotExist: {},
                      wafCountry: {},
                      wafIsp: {},
                      wafHttpMethod: {},
                      wafRate: {},
                      wafRateLimitToken: {},
                      wafOwasp: {},
                      wafRewaf: {},
                      wafIpExclude: {},
                      wafUriExclude: {},
                      wafHeadersExclude: {},
                      wafProxyType: {},
                      wafJa3Hashes: {},
                      wafWithL3BucketList: {},
                      createdDate: {},
                      modifiedDate: {},
                      description: description(this),
                      status: {},
                      objectLog: {},
                  }
                : {
                      action: {},
                      createBy: {},
                      groupName: groupName(this),
                      ruleName: ruleName(this),
                      _id: {},
                      usedByFQDNConfigLength: {},
                      wafAction: {},
                      wafCustomHtmlPageName: {},
                      wafDenyHtmlPageName: {},
                      wafOriginPolicyName: {},
                      wafIsDenyThenBucket: {},
                      //   isAllowTcpReset: {},
                      wafDenyThenBucketRate: {},
                      wafBucketTime: {},
                      wafBucketPreSslDeny: {},
                      wafBucketPreSslDenyThreshold: {},
                      wafIsGlobalBucketRecord: {},
                      wafSpeedLimit: {},
                      wafRedirectUrl: {},
                      wafRedirectHttpCode: {},
                      wafSetReqHeaders: {},
                      wafSetResHeaders: {},
                      wafHotlinkSecretKey: {},
                      wafHotlinkTimeToLive: {},
                      wafHotlinkQueryArgument: {},
                      settingZoneExplain: {},
                      wafIp: {},
                      wafUri: {},
                      wafHeaderType: {},
                      wafHeaders: {},
                      wafHeadersSet: {},
                      wafHeadersNotExist: {},
                      wafCountry: {},
                      wafIsp: {},
                      wafHttpMethod: {},
                      wafRate: {},
                      wafRateLimitToken: {},
                      wafOwasp: {},
                      wafRewaf: {},
                      wafIpExclude: {},
                      wafUriExclude: {},
                      wafHeadersExclude: {},
                      wafProxyType: {},
                      wafJa3Hashes: {},
                      wafWithL3BucketList: {},
                      createdDate: {},
                      modifiedDate: {},
                      description: description(this),
                      status: {},
                      objectLog: {},
                  };
            // 清除未啟用欄位
            let filterDetect = this.$store.state.platformPlan.multiTenancyConfigs.wafSetting.detect.filter(
                (detect) => !detect.isShow
            );
            filterDetect.forEach((detect) => {
                detect.rmFornt.forEach((rmItem) => {
                    delete wafFileds[rmItem];
                });
            });
            return wafFileds;
        },
    },
    watch: {
        "$i18n.locale": {
            deep: true,
            handler: function () {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
            },
        },
    },
    methods: {
        getAssetData() {
            getGroupAsset({
                category: this.assetCategory,
                groupNames: [this.$store.state.queryGroupName],
            }).then((res) => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage = { used, max, available };
            });
        },
    },
    mounted() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
        this.getAssetData();
    },
    created() {
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent) => {
            bus.$emit(busEvent);
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/WafRules/Page.vue